//加密
export function encryptAes(word) {
    return word
}
//解密
export function decryptAes(code) {
    return code
}


